module.exports = __webpack_public_path__ + "img/02.7d87d9e8.png";